// Import model
import { Fcb2BProductTypeOptionCondition } from '../models/Fcb2BProductTypeOptionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { Fcb2BProductTypeOptionIndexedFields } from '../models/Fcb2BProductTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { Fcb2BProductTypeOptionIndexedFieldsSerializer } from './Fcb2BProductTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Fcb2BProductTypeOptionCondition - handles JSON serialization and deserialization with type validation
 */
export class Fcb2BProductTypeOptionConditionSerializer {
  /**
   * Deserializes a JSON string into a Fcb2BProductTypeOptionCondition instance
   */
  static deserialize(json: string): Fcb2BProductTypeOptionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Fcb2BProductTypeOptionCondition instance
   */
  static fromObject(obj: any): Fcb2BProductTypeOptionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Fcb2BProductTypeOptionCondition');
    }


    const instance: Fcb2BProductTypeOptionCondition = {
      fieldName: obj['fieldName'] as Fcb2BProductTypeOptionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Fcb2BProductTypeOptionCondition instances
   */
  static deserializeArray(json: string): Fcb2BProductTypeOptionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Fcb2BProductTypeOptionCondition instance to a JSON string
   */
  static serialize(instance: Fcb2BProductTypeOptionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Fcb2BProductTypeOptionCondition instance to a plain object
   */
  static toObject(instance: Fcb2BProductTypeOptionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of Fcb2BProductTypeOptionCondition instances to a JSON string
   */
  static serializeArray(instances: Fcb2BProductTypeOptionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
